// src/pages/sales/LoungeSalesSummary.jsx
import React from 'react';
import SalesSummary from '../SalesSummary';

const LoungeSalesSummary = () => {
  return <SalesSummary locationKey="lounge" />;
};

export default LoungeSalesSummary;